<template>
  <div>
    <el-table
      :empty-text="$t('NO_DATA')"
      :data="tableData.results"
      v-loading="loading"
      :stripe="true"
      :default-sort="{ prop: 'id', order: 'descending' }"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('VEHICLE_TITLE')"
        width="150"
      >
        <template slot-scope="scope">
          <LicensePlate
            :vehicle="scope.row.company_vehicle.vehicle"
            :license_plate="scope.row.company_vehicle.license_plate"
            :chars="alphaList"
          ></LicensePlate>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('used_quota_vehicle')"
        width="150"
      >
        <template v-if="scope.row.used_quota" slot-scope="scope">
          <LicensePlate
            :vehicle="scope.row.used_quota.vehicle"
            :license_plate="scope.row.used_quota.license_plate"
            :chars="alphaList"
          ></LicensePlate>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FULL_NAME')"
        width="120"
      >
        <template slot-scope="scope" v-if="scope.row.driver">
          <div :data-title="$t('FULL_NAME')">
            {{ scope.row.driver.first_name + ' ' + scope.row.driver.last_name }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        align="center"
        :label="$t('DISTANCE_TRAVEL')"
        width="120"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('DISTANCE_TRAVEL')"
            v-html="
              $options.filters.numberSeperator1(scope.row.odometer / 1000)
            "
          ></div>
        </template>
      </el-table-column>

      <el-table-column
        prop="fuel_type"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FUEL_TYPE')"
        width="85"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('FUEL_TYPE')"
            class="text-sm"
            v-if="scope.row.fuel_type"
          >
            {{
              $i18n.locale == 'fa'
                ? scope.row.fuel_type.fa_title
                : scope.row.fuel_type.en_title
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        align="center"
        :label="$t('amount')"
        width="100"
      >
        <template slot-scope="scope">
          <div
            :data-title="$t('amount')"
            v-html="$options.filters.numberSeperator1(scope.row.amount)"
          ></div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('price_per_liter')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('price_per_liter')" class="flex">
            <span
              v-html="
                $options.filters.numberSeperator1(scope.row.price_per_liter)
              "
            ></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('total_paid')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('total_paid')" class="flex">
            <span
              v-html="$options.filters.numberSeperator(scope.row.total_paid)"
            ></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DIFFERENCE_PERCENTAGE')"
        width="90"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DIFFERENCE_PERCENTAGE')" class="flex">
            <span
              v-if="scope.row.cost_difference_percentage !== undefined"
              v-html="
                (scope.row.cost_difference_percentage > 0 ? '+' : '') +
                scope.row.cost_difference_percentage +
                '%'
              "
              :class="{
                'text-green-500': scope.row.cost_difference_percentage < 0,
                'text-red-500': scope.row.cost_difference_percentage > 0,
                'text-gray-500': scope.row.cost_difference_percentage === 0,
              }"
              class="ltr"
            ></span>
            <span class="ml-2">
              <i
                v-if="scope.row.cost_difference_percentage > 0"
                class="el-icon-top text-red-500 text-lg"
              ></i>
              <i
                v-else-if="scope.row.cost_difference_percentage < 0"
                class="el-icon-bottom text-green-500 text-lg"
              ></i>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DATE_')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DATE_')">
            {{ gregorianToJalali(scope.row.date) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="" width="150">
        <template slot-scope="scope">
          <div class="fixed-column">
            <tableFeatures
              :Editable="false"
              @remove="remove(scope.row.id)"
              @open="open($event)"
              :description="scope.row.description"
              :title="$t('fuel_transaction')"
              :isDeleteable="true"
              :view="false"
            >
              <i
                class="
                  el-icon-edit-outline
                  text-xl
                  cursor-pointer
                  text-yellow-500
                "
                @click="editTransaction(scope.row)"
              ></i>
            </tableFeatures>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- Use our new component -->
    <FuelTransactionForm
      :show.sync="showTransactionForm"
      :transaction="currentTransaction"
      @transaction-updated="handleTransactionUpdated"
      formType="fullForm"
    />
  </div>
</template>

<script>
import tableFeatures from '@/components/elements/tableFeatures'
import LicensePlate from '@/components/cars/LicensePlate'
import { licenseChars } from '@/api/global'
import { numberWithSpaces } from '@/mixins/numberWithSpaces'
import { open } from '@/mixins/openDesc'
import { removeTransaction } from '@/api/fuel'
import FuelTransactionForm from '@/components/fuel/FuelTransactionForm'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
import { currency } from '@/mixins/currency'

export default {
  props: ['tableData', 'loading'],
  mixins: [numberWithSpaces, open, gregorianToJalali, currency],
  data() {
    return {
      alphaList: [
        {
          code: '',
          char: '',
          id: '',
        },
      ],
      showTransactionForm: false,
      currentTransaction: {},
    }
  },
  components: {
    LicensePlate,
    tableFeatures,
    FuelTransactionForm,
  },
  mounted() {
    licenseChars.api().then((res) => {
      this.alphaList = res
    })
  },
  methods: {
    remove(id) {
      removeTransaction.api(id).then((res) => {
        if (res) {
          this.$notify.success({
            title: this.$i18n.t('SOMETHING_DELETED', {
              type: this.$i18n.t('fuel_transaction'),
            }),
            duration: 4000,
            customClass: 'info_msg',
          })
          this.$emit('transaction-removed', id)
        }
      })
    },

    editTransaction(transaction) {
      this.currentTransaction = {
        typeTransaction: transaction.used_quota ? 0 : 1,
        company_vehicle: transaction.company_vehicle.id,
        used_quota: transaction.used_quota ? transaction.used_quota.id : null,
        odometer: this.currency(transaction.odometer / 1000),
        date: this.gregorianToJalali(transaction.date),
        amount: this.currency(transaction.amount),
        price_per_liter: this.currency(transaction.price_per_liter),
        total_paid: this.currency(transaction.total_paid),
        fuel_type: {
          id: transaction.fuel_type.id,
        },
        driver: {
          id: transaction.driver ? transaction.driver.id : '',
        },
        description: transaction.description || '',
        id: transaction.id, // Store the ID for update operation
      }

      // Show the form
      this.showTransactionForm = true
    },

    handleTransactionUpdated(updatedTransaction) {
      // Emit event to parent component to update the specific transaction in the list
      this.$emit('transaction-updated', updatedTransaction)
    },
  },
}
</script>
